import { render, staticRenderFns } from "./KInputFileNew.vue?vue&type=template&id=547e3fca&"
import script from "./KInputFileNew.vue?vue&type=script&lang=js&"
export * from "./KInputFileNew.vue?vue&type=script&lang=js&"
import style0 from "./KInputFileNew.vue?vue&type=style&index=0&id=547e3fca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports